import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from "@angular/core";
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {faCalendar, faCircleNotch} from '@fortawesome/free-solid-svg-icons';
import {ActiveConsumptionPeriod} from "../../../../models/rt2012/activeConsumptionPeriod";
import {NgbDate} from "@ng-bootstrap/ng-bootstrap";
import {fadeInUpOnEnterAnimation} from '../../../../animations';
import {Logement} from "../../../../models/logement";
import {
  ActiveConsumptionPeriodService
} from "../../../../services/rt2012/active-consumption-period/active-consumption-period.service";
import {EnergieEnum} from "../../suivi-des-consommations/enums/EnergieEnum";

@Component({
    selector: 'app-active-consumption-period-modal',
    templateUrl: './active-consumption-period-modal.html',
    styleUrls: ['./active-consumption-period-modal.scss'],
    animations: [
        fadeInUpOnEnterAnimation()
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ActiveConsumptionPeriodModalComponent {
  updating = false;
  submitting = false;
  periodForm: UntypedFormGroup;
  faCircleNotch = faCircleNotch;
  faCalendar = faCalendar;

  @Output() public periodRefresh = new EventEmitter();

  @Input() public energy: EnergieEnum;
  @Input() public logement: Logement;
  @Input() public period: ActiveConsumptionPeriod = null;

  constructor(private activeConsumptionPeriodService: ActiveConsumptionPeriodService) {
  }

  ngOnInit() {
    if (typeof this.period === 'undefined' || null === this.period) {
      this.period = new ActiveConsumptionPeriod;
    }
    let startDatePeriod = null;
    let endDatePeriod = null;
    if (this.period.startDatePeriod !== null) {
      startDatePeriod = new NgbDate(this.period.startDatePeriod.getFullYear(), this.period.startDatePeriod.getMonth() + 1, this.period.startDatePeriod.getDate());
    }
    if (this.period.endDatePeriod !== null) {
      endDatePeriod = new NgbDate(this.period.endDatePeriod.getFullYear(), this.period.endDatePeriod.getMonth() + 1, this.period.endDatePeriod.getDate());
    }
    this.periodForm = new UntypedFormGroup({
      startDatePeriod: new UntypedFormControl(startDatePeriod, [
        Validators.required,
      ]),
      endDatePeriod: new UntypedFormControl(endDatePeriod, [
        Validators.required,
      ])
    });

    this.updating = this.period !== null;
  }

  private ngDAteToDate(date): Date {
    return new Date(date.year, date.month - 1, date.day, 12);
  }

  onSubmit() {
    this.period.startDatePeriod = this.ngDAteToDate(this.periodForm.controls.startDatePeriod.value);
    this.period.endDatePeriod = this.ngDAteToDate(this.periodForm.controls.endDatePeriod.value);
    this.activeConsumptionPeriodService.create(this.period, this.logement, this.energy);
    this.periodRefresh.emit();
  }
}
